import { getInjector } from '../../utils/getInjector';

export const onTrackCartPageLoad = async (payload) => {
  const { cartItems, cartSubtotal } = payload;
  const injector = await getInjector();
  const Analytics = injector.get('Analytics');
  const gaService = injector.get('gaService');
  const trackerService = injector.get('trackerService');

  // Google Analysis
  if (Analytics.configuration.enhancedEcommerce) {
    gaService.sendPageView();
  }

  // Facebook Pixel
  trackerService.fbInitiateCheckoutForCartLink(cartItems, cartSubtotal);
};
